// third-party
import { FormattedMessage } from 'react-intl';

// assets
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
const icons = {
    AccessTimeOutlinedIcon
};

// ==============================|| MENU ITEMS - TIMESHEET ||============================== //

const timesheet = {
    id: 'timesheet',
    title: <FormattedMessage id="timesheet" />,
    icon: icons.AccessTimeOutlinedIcon,
    type: 'group',
    url: 'timesheet',
    roles: ['employee', 'employer']
};

export default timesheet;
